export const SIDE_NAVBAR_AS_PER_MODULE = {
  CX: [
    {
      link: "/dashboard",
      label: "Dashboard",
      shortLabel: "dashboard",
      active: "",
      isLink: true,
      iconName: "Gauge",
      child: [],
    },
    {
      link: "/dashboard/billing",
      label: "Billing & Payments",
      shortLabel: "billing-payments",
      active: "",
      isLink: true,
      iconName: "users-round",
      child: [],
    },
    {
      link: "/usage-consumption",
      label: "Usage & Consumption",
      shortLabel: "usage-consumption",
      active: "",
      isLink: true,
      iconName: "user-round-plus",
      child: [],
    },
    {
      link: "/notification",
      label: "Notifications",
      shortLabel: "notifications",
      active: "",
      isLink: true,
      iconName: "wrench",
      child: [],
    },
    {
      link: "/dashboard/requests",
      label: "Service Requests",
      shortLabel: "service-requests",
      active: "",
      isLink: true,
      iconName: "circle-alert",
      child: [],
    },
    {
      link: "/request-tracker",
      label: "Request Tracker",
      shortLabel: "request-tracker",
      active: "",
      isLink: true,
      iconName: "power-off",
      child: [],
    },
    {
      link: "/profile",
      label: "Profile",
      shortLabel: "profile",
      active: "",
      isLink: true,
      iconName: "credit-card",
      child: [],
    },
    {
      link: "/preferences",
      label: "Preferences",
      shortLabel: "preferences",
      active: "",
      isLink: true,
      iconName: "dollar-circle",
      child: [],
    },
    {
      link: "/faqs",
      label: "FAQs",
      shortLabel: "faqs",
      active: "", 
      isLink: true,
      iconName: "settings",
      child: [],
    },
     {
      link: "/contactUs",
      label: "Contact Us",
      shortLabel: "contact-us",
      active: "", 
      isLink: true,
      iconName: "settings",
      child: [],
    },
  ],
};

export const ICONS = [
  
  {
    link: "/cx/dashboard",
    lucideIcon: "Phone",
    name: "Call Center",
    description:
      "Handle customer support interactions and manage call center activities.",
    hoverDesc: "",
    active: true,
    module: "CX",
  },
];
